import {dateTimeStringFromApiToDate, nullableDateTimeStringFromApiToDate} from "../../../index";
import {DashboardUddannelsesplanStatusEnum} from "../../vejledning/uddannelsesplan/DashboardUddannelsesplanStatusEnum";
import {VejledningDatoKategoriEnum} from "../dashboardVejledersamtaler/VejledningDatoKategoriEnum";

export class DashboardUddannelsesplanModel {
    forloebId: string;
    uddannelsesplanId: string;
    afholdtDato?: Date;
    oprettetDato: Date;
    datoKategori: VejledningDatoKategoriEnum;
    status: DashboardUddannelsesplanStatusEnum;

    static Build(responseModel: DashboardUddannelsesplanResponseModel): DashboardUddannelsesplanModel {
        let model = new DashboardUddannelsesplanModel();
        model.forloebId = responseModel.forloebId;
        model.uddannelsesplanId = responseModel.uddannelsesplanId;
        model.afholdtDato = nullableDateTimeStringFromApiToDate(responseModel.afholdtDato);
        model.oprettetDato = dateTimeStringFromApiToDate(responseModel.oprettetDato);
        model.status = responseModel.status;
        return model;
    }
}

export type DashboardUddannelsesplanResponseModel = {
    forloebId: string;
    uddannelsesplanId: string;
    afholdtDato?: string;
    oprettetDato: string;
    status: DashboardUddannelsesplanStatusEnum;
}
